import * as S from './style';
import { menuList } from '@/constants/menu';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import LinkIcon from '@/components/Icon/LinkIcon';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';
interface MobileMenuProps {
	isOpen: boolean;
	onClickIsOpen: (isOpen: boolean) => void;
}
interface SubMenu {
	path: string;
	menu: string;
}
const MobileMenu = ({ isOpen, onClickIsOpen }: MobileMenuProps) => {
	const [openMenus, setOpenMenus] = useState<number[]>([]);
	const navigate = useNavigate();
	const { showModal } = useModalStore();
	const { isLogin } = useTokenStore();
	const toggleSubMenu = (index: number) => {
		openMenus.includes(index) ? setOpenMenus(openMenus.filter((item) => item !== index)) : setOpenMenus([...openMenus, index]);
	};
	const onClickCloseButton = () => {
		document.body.classList.remove('hidden');
		onClickIsOpen(false);
	};

	const onClickMenu = ({ path, menu }: SubMenu) => {
		document.body.classList.remove('hidden');
		onClickIsOpen(false);
		navigate(path ?? '', { state: { menu: menu } });
	};
	const onClickSubMenu = (path: string, title: string) => {
		if (title === '회원가입') {
			if (isLogin()) {
				onClickCloseButton();
				showModal('이미 노화학회 회원이십니다.', 'confirm');
				return;
			} else {
				onClickMenu({ path: '/auth/signup', menu: title });
				return;
			}
		}

		if (title === '연회비 납부') {
			if (!isLogin()) {
				onClickCloseButton();
				showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
				return;
			}
		}
		onClickMenu({ path, menu: title });
	};

	const handleContentClick = (menu: any, index: number) => {
		if (menu.mainPath) {
			if (menu.mainPath === 'link') {
				window.open('https://www.e-agmr.org/');
				return;
			}
			onClickMenu({ path: menu.mainPath ?? '', menu: menu.mainMenu ?? '' });
			return;
		}
		// No mainPath: toggle submenu
		toggleSubMenu(index);
	};

	return (
		<S.ModalOverlay isOpen={isOpen}>
			<S.CloseButton onClick={onClickCloseButton} aria-label="Close menu" />
			<S.ModalContent>
				{menuList.map((menu, index) => (
					<div key={uuid()} className="content" onClick={() => handleContentClick(menu, index)}>
						{menu.mainPath ? (
							<S.MainMenu>
								{menu.mainPath === 'link' ? (
									<S.MainTextWithIcon isOpen={isOpen}>
										{menu.mainMenu}
										<LinkIcon width="20" height="20" />
									</S.MainTextWithIcon>
								) : (
									<S.MainTextWithIcon isOpen={isOpen}>
										{menu.mainMenu}
									</S.MainTextWithIcon>
								)}
							</S.MainMenu>
						) : (
							<S.MainMenu>{menu.mainMenu}</S.MainMenu>
						)}
						{menu.subMenu && openMenus.includes(index) && (
							<>
								{menu.subMenu?.map((subMenu, i) => (
									<S.SubMenu key={i}>
										<S.TextWithIcon
											isOpen={isOpen}
											onClick={(e) => {
												e.stopPropagation();
												onClickSubMenu(subMenu.path ?? '', subMenu.title ?? '');
											}}
										>
											<div>{subMenu.title}</div>
											<SingleArrowNext width="20" height="20" iconColor="#868E96" />
										</S.TextWithIcon>
									</S.SubMenu>
								))}
							</>
						)}
					</div>
				))}
			</S.ModalContent>
		</S.ModalOverlay>
	);
};
export default MobileMenu;
